// This file is AUTOGENERATED, do not edit it manually!!!

export const koPeopleTemplates = {
    nomatch_text: 'Sorry, er is niets gevonden',
    roles: 'Rollen',
    teams: 'Teams',
    users: 'Gebruikers',
};
